import React from 'react';
import { motion } from 'framer-motion';
import { UserPlus, AlertCircle, Sparkles } from 'lucide-react';
import { Button } from '../../../../components/ui/Button';
import { Input } from '../../../../components/ui/Input';
import { Select } from '../../../../components/ui/Select';
import { type Classroom } from '../../../../accounts';
interface NewStudentStepProps {
  activeClassroom: Classroom | null;
  classrooms: Classroom[];
  newStudentName: string;
  setNewStudentName: (name: string) => void;
  fallbackGrade: string;
  setFallbackGrade: (grade: string) => void;
  fallbackClassroomId: string;
  setFallbackClassroomId: (id: string) => void;
  formError: string;
  onSubmit: (e: React.FormEvent) => void;
  onBack: () => void;
}
export function NewStudentStep({
  activeClassroom,
  classrooms,
  newStudentName,
  setNewStudentName,
  fallbackGrade,
  setFallbackGrade,
  fallbackClassroomId,
  setFallbackClassroomId,
  formError,
  onSubmit,
  onBack
}: NewStudentStepProps) {
  return <motion.form key="new" initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} transition={{
    duration: 0.2
  }} onSubmit={onSubmit} className="space-y-6 max-w-lg mx-auto" data-id="element-5166">
      <div className="text-center mb-6" data-id="element-5167">
        <div className="w-14 h-14 bg-indigo-100 text-indigo-600 rounded-2xl flex items-center justify-center mx-auto mb-3 shadow-sm" data-id="element-5168">
          <UserPlus className="w-7 h-7" data-id="element-5169" />
        </div>
        <h3 className="text-xl font-black text-slate-900 mb-1" data-id="element-5170">
          Nieuwe leerling
        </h3>
        {activeClassroom && <p className="text-sm text-slate-500" data-id="element-5171">
            Wordt automatisch toegevoegd aan{' '}
            <strong data-id="element-5172">{activeClassroom.name}</strong> (Groep{' '}
            {activeClassroom.groupLevel})
          </p>}
      </div>

      <div className="space-y-4" data-id="element-5173">
        <Input variant="admin" size="lg" label="Naam leerling" id="studentName" value={newStudentName} onChange={e => setNewStudentName(e.target.value)} placeholder="Bijv. Emma de Vries" autoFocus data-id="element-5174" />

        {/* Only show grade/classroom pickers if no classroom is selected */}
        {!activeClassroom && <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-5175">
            <Select variant="admin" size="lg" label="Groep" id="studentGrade" value={fallbackGrade} onChange={e => setFallbackGrade(e.target.value)} options={[{
          value: '6',
          label: 'Groep 6'
        }, {
          value: '7',
          label: 'Groep 7'
        }, {
          value: '8',
          label: 'Groep 8'
        }]} data-id="element-5176" />
            {classrooms.length > 0 && <Select variant="admin" size="lg" label="Klas" id="targetClassroom" value={fallbackClassroomId} onChange={e => setFallbackClassroomId(e.target.value)} placeholder="Geen klas" options={classrooms.map(c => ({
          value: c.id,
          label: c.name
        }))} data-id="element-5177" />}
          </div>}
      </div>

      {formError && <div className="text-sm text-red-600 flex items-center gap-2 bg-red-50 p-3 rounded-xl border border-red-100" data-id="element-5178">
          <AlertCircle className="w-4 h-4 flex-shrink-0" data-id="element-5179" />
          <span className="font-medium" data-id="element-5180">{formError}</span>
        </div>}

      <div className="flex gap-3 pt-2" data-id="element-5181">
        <Button type="button" variant="secondary" onClick={onBack} className="flex-1" data-id="element-5182">
          Terug
        </Button>
        <Button type="submit" className="flex-[2] bg-indigo-600 hover:bg-indigo-700 text-white" data-id="element-5183">
          <Sparkles className="w-4 h-4 mr-2" data-id="element-5184" />
          Aanmaken
        </Button>
      </div>
    </motion.form>;
}